if (!customElements.get('althos-gallery')) {
  customElements.define('althos-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-button]');
        if (!button || !this.contains(button)) return;
        const target = button.getAttribute('aria-controls');
        this.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel.id !== target; });
        this.querySelectorAll('[data-gallery-button]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
      });
    }
  });
}
